import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTopButton from './components/ScrollToTopButton';
import WhatsAppButton from './components/WhatsAppButton';
import Loader from './components/Loader';

// Lazy loading components for better Vercel performance
const Home = lazy(() => import('./pages/Home'));
const SubjectMCQs = lazy(() => import('./pages/SubjectMCQs'));
const DepartmentSubjects = lazy(() => import('./pages/DepartmentSubjects'));
const SubjectByName = lazy(() => import('./pages/SubjectByName'));
const SubjectTopics = lazy(() => import('./pages/SubjectTopics'));
const TopicMCQs = lazy(() => import('./pages/TopicMCQs'));
const QuizSubject = lazy(() => import('./pages/QuizSubject'));
const QuizAttempt = lazy(() => import('./pages/QuizAttempt'));
const PastPaperSubject = lazy(() => import('./pages/PastPaperSubject'));
const TopicPastMCQs = lazy(() => import('./pages/TopicPastMCQs'));
const Quiz = lazy(() => import('./pages/Quiz'));
const Notes = lazy(() => import('./pages/Notes'));
const PastPapers = lazy(() => import('./pages/PastPapers'));
const PastPaperMCQs = lazy(() => import('./pages/PastPaperMCQs'));
const OnlineLectures = lazy(() => import('./pages/OnlineLectures'));
const LectureDashboard = lazy(() => import('./pages/LectureDashboard'));
const SubjectLectures = lazy(() => import('./pages/SubjectLectures'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const BlogList = lazy(() => import('./pages/BlogList'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));
const Login = lazy(() => import('./pages/Login'));
const Admin = lazy(() => import('./pages/Admin'));
const NotesSubject = lazy(() => import('./pages/NotesSubject'));
const TopicNotes = lazy(() => import('./pages/TopicNotes'));
const NoteView = lazy(() => import('./pages/NoteView'));
const SelectSubject = lazy(() => import('./pages/SelectSubject'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions'));
const Courses = lazy(() => import('./pages/Courses'));
const CourseDetail = lazy(() => import('./pages/CourseDetail'));
const CourseLearn = lazy(() => import('./pages/CourseLearn'));
const MyCourses = lazy(() => import('./pages/MyCourses'));
const StudentAuth = lazy(() => import('./pages/StudentAuth'));

// Loading component for Suspense fallback
const PageLoader = () => <Loader />;

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            
            <Route path="/mcqs/department/:deptId" element={<DepartmentSubjects />} />
            <Route path="/mcqs/:subjectId" element={<SubjectMCQs />} />
            <Route path="/mcqs/subject/:name" element={<SubjectByName />} />
            <Route path="/mcqs/:subjectId/topics" element={<SubjectTopics />} />
            <Route path="/mcqs/topic/:topicId" element={<TopicMCQs />} />
            <Route path="/mcqs/topic/:topicId/page/:page" element={<TopicMCQs />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/select-subject/notes/other" element={<Navigate to="/select-subject/notes/pdf-notes" replace />} />
            <Route path="/select-subject/:mode" element={<SelectSubject />} />
            <Route path="/select-subject/:mode/:type" element={<SelectSubject />} />
            <Route path="/quiz/subject/:name" element={<QuizSubject />} />
            <Route path="/quiz/attempt" element={<QuizAttempt />} />
            <Route path="/quiz/:category/*" element={<Quiz />} />
            <Route path="/past-papers/subject/:name" element={<PastPaperSubject />} />
            <Route path="/past-papers/topic/:topicId" element={<TopicPastMCQs />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/notes/:category/*" element={<Notes />} />
            <Route path="/notes/other/subject/:name" element={<Navigate to="/select-subject/notes/pdf-notes" replace />} />
            <Route path="/notes/other/topic/:topicId" element={<Navigate to="/select-subject/notes/pdf-notes" replace />} />
            <Route path="/notes/other/pdf/:id" element={<Navigate to="/select-subject/notes/pdf-notes" replace />} />
            <Route path="/notes/:type/subject/:name" element={<NotesSubject />} />
            <Route path="/notes/:type/topic/:topicId" element={<TopicNotes />} />
            <Route path="/notes/:type/pdf/:id" element={<NoteView />} />
            <Route path="/past-papers" element={<PastPapers />} />
            <Route path="/past-papers/paper/:paperId" element={<PastPaperMCQs />} />
            <Route path="/past-papers/paper/:paperId/page/:page" element={<PastPaperMCQs />} />
            <Route path="/past-papers/:category/*" element={<PastPapers />} />
            <Route path="/online-lectures" element={<OnlineLectures />} />
            <Route path="/online-lectures/:category/*" element={<OnlineLectures />} />
            <Route path="/lectures-dashboard" element={<LectureDashboard />} />
            <Route path="/lectures/:subjectSlug" element={<SubjectLectures />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blogs" element={<BlogList />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/login" element={<Login />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetail />} />
            <Route path="/courses/:id/learn" element={<CourseLearn />} />
            <Route path="/my-courses" element={<MyCourses />} />
            <Route path="/student/login" element={<StudentAuth />} />
            <Route path="/student/register" element={<StudentAuth />} />
            <Route path="/admin" element={<Navigate to="/qasimmian4655547" replace />} />
            <Route path="/qasimmian4655547" element={<Admin />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
}

export default App;
